import { defineStore } from 'pinia'

import useFavoritesLinksManager from '@/composables/managers/useFavoritesLinksManager'

export const useCompanyFavoriteLinksStore = defineStore('companyFavoriteLinks', () => {

	const {
		favoritePresetLoadingState,

		isLoadingFavoritesStatus,
		isLoadedFavoritesStatus,
		isCreatingFavoriteLinkStatus,

		favoritesLinks,
		getFirstOrCreateFavoritesPreset,

		createFavoriteGroup,
		changeFavoriteGroupName,
		deleteFavoriteGroup,

		createFavoriteLink,
		changeFavoriteLink,
		deleteFavoriteLink,

		onChangeOrdering,
	} = useFavoritesLinksManager()

	function $reset() {
		// FIXME: implement this method
	}

	return {
		favoritePresetLoadingState,

		isLoadingFavoritesStatus,
		isLoadedFavoritesStatus,
		isCreatingFavoriteLinkStatus,

		favoritesLinks,
		getFirstOrCreateFavoritesPreset,

		createFavoriteGroup,
		changeFavoriteGroupName,
		deleteFavoriteGroup,

		createFavoriteLink,
		changeFavoriteLink,
		deleteFavoriteLink,

		onChangeOrdering,

		$reset,
	}

})
